import {
    SALES_STATS_REQUEST_START,
    SALES_STATS_REQUEST_SUCCESS,
    SALES_STATS_REQUEST_FAILED,
    SALES_STATS_REQUEST_NO_PERMISSION,
    SALES_STATS_DELETE
} from '../actions/SalesStatsActions';

const initialState = {
    status: 'Initialize'
};

export default function SalesStatsReducer(state = initialState, action) {

    if (!action) {
        return state;
    }

    switch (action.type) {
        case SALES_STATS_REQUEST_START:
            return {
                ...state, status: 'request', date: action.date
            };
        case SALES_STATS_REQUEST_SUCCESS:
            return {...state, status: 'success', data: action.data};
        case SALES_STATS_REQUEST_NO_PERMISSION:
            return {...state, status: 'no_permission'};
        case SALES_STATS_REQUEST_FAILED:
            return {...state, status: 'error'};
        default:
            return state;
    }
}
